import { t } from "copy/t";
import SEO from "components/SEO";
import LegalLinks from "./LegalLinks";

/**
 * The expired state of a public gallery or a single shared photo.
 *
 * rails answers `410 {gallery_expired: true}` for a gallery a free first event
 * unpublished after its retention (nothing is deleted; a purchase restores it),
 * on `load-gifs` and on `GET /api/v2/gifs/:id`. The request layer rejects with
 * the body spread onto the error, so callers pass `isGalleryExpired(error)`.
 * No channel data comes with a 410, so this renders no branding.
 */
export const isGalleryExpired = (error) =>
  error?.statusCode === 410 && error?.gallery_expired === true;

const GalleryExpired = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-black px-4">
    <SEO title={t("galleryExpired.title")} description={t("galleryExpired.body")} noIndex={true} />
    <div className="flex flex-col gap-4 text-center text-white/70 max-w-[460px]">
      <h1 className="font-inter text-3xl font-extrabold">{t("galleryExpired.title")}</h1>
      <p className="text-base">{t("galleryExpired.body")}</p>
      <div className="flex justify-center">
        <LegalLinks />
      </div>
    </div>
  </div>
);

export default GalleryExpired;
